/* global document, window */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

require('public/css/product.scss');

var THE_SCRIPT = function () {
	const dust = require('public/js/lib/dust');
	const $onReady = require('./lib/on-ready');

	// Core
	require('core-js/es6/number');
	require('core-js/fn/array/is-array');
	require('core-js/fn/array/for-each');
	require('core-js/fn/array/find');
	require('core-js/fn/array/map');
	require('core-js/fn/array/includes');
	require('public/js/components/vehicle-picker');
	require('public/js/listeners/get-vehicle-picker');

	const isObjectLike = require('lodash/isObjectLike');
	const get = require('lodash/get');
	const isEmpty = require('lodash/isEmpty');
	const { trackImpressionsEvent, trackDetailsViewEvent } = require('public/js/lib/adobe-dtm-helper');
	const { validatePostalCode } = require('public/js/lib/postal-code-helper');
	const {
		getInventoryMessage,
		getShippingMessageTitle,
		getShippingMessage,
		getShippingEstimateMessage,
		getPickupMessage,
		getInventoryMessageCustomerId,
		getInventoryMessageWarehouseId,
		handleZipChange,
		handleZipChangeEvent
	} = require('public/js/lib/product-message-utils');

	const RecommendedProductsTempl = require('public/templates/modules/product_recommended/recommended-products.dust');
	const ProductImagesTempl = require('public/templates/modules/product_images/product-images.dust');
	const ProductFitmentTempl = require('public/templates/modules/product_fitment/product-fitment.dust');
	const ProductDetailsTempl = require('public/templates/modules/product_details/product-details.dust');

	const { getNumberFormatter } = require('public/js/lib/format-helper');
	const NumberFormat = getNumberFormatter();

	const OPTION_ATTRIBUTES = {
		data_option_id: 'data-option-id',
		name: 'name',
		data_content: 'data-content',
		data_placement: 'data-placement',
		value: 'value',
		selected: 'selected',
		disabled: 'disabled',
		data_option_value: 'data-option-value',
	};

	const AVAILABILITY = {
		available_for_sale: 'Available for Sale',
		discontinued: 'Discontinued',
		not_for_sale: 'Not for Sale',
		on_backorder: 'On Backorder',
		call_for_price: 'Call for Price',
		call_for_availability: 'Call for Availability',
	};

	const product = {
		data: null,
		optionValues: [],
		bundleDetails: {},
		productOptionValues: {},
	};

	let check_product_availability = null;

	product.setProductData = function (productData) {
		this.data = productData;
		this.$addToCartBtn = rp$('.product-purchase button.add-to-cart');

		Object.keys(this.data.all_product_options).forEach(productSku => {
			let dataOptionsArray = this.data.all_product_options[productSku];
			dataOptionsArray.forEach((option) => {
				this.optionValues = this.optionValues.concat(option.values);
				this.productOptionValues[option.id] = option.values;
			});
		});

		Object.keys(this.data.all_product_details).forEach(keyTemp => {
			const productDetails = this.data.all_product_details[keyTemp];
			const componentDetails = { 'sku_stripped': productDetails.sku_stripped, 'title': productDetails.title, 'quantity': productDetails.bundle_quantity, 'price': productDetails.price, 'catalog': productDetails.catalog };
			this.bundleDetails[productDetails.sku_stripped] = componentDetails;
		});
	};

	product.getRecommendedParts = function (catalog, skuStripped, limit, displayList) {
		rp$(document).trigger('productGetRecommendations:request');
		$ajax({
			method: 'GET',
			dataType: 'json',
			data: {
				catalog: catalog,
				sku: skuStripped,
				limit,
				displayList,
			},
			url: '/ajax/product/get-recommended-parts',
			success: (recommendedProducts, status/*, xhr*/) => {
				if (status !== 'success') { return; }
				const products = recommendedProducts.products || recommendedProducts;
				if (!products || products.length === 0) { return; }
				let recommendationsHtml;

				/* Update Tracking Products From Response for Enhanced Ecommerce
				.*-----------------------------------------*/
				if (window.tracking) {
					window.tracking.ec.products = products.map((product, index) => {
						return {
							id: product.sku_stripped,
							name: product.name,
							brand: product.brand,
							list: 'Recommended Products',
							position: (index + 1),
							price: (product.call_for_price) ? null : product.price,
						};
					});
					// Add product impressions on each Enhanced Ecommerce tracker
					rp_app.track.track_ec_impressions();
					// Create an event to send over impressions
					const event_args = ['EnhancedEcommerce', 'TrackImpressions', 'RecommendedProducts'];
					rp_app.track.track_event(event_args, { nonInteraction: true }, 'ec');
					trackImpressionsEvent(window.tracking.ec.products, 'Featured Products');
				}

				if (recommendedProducts.listings_html) {
					rp$(document).trigger('productGetRecommendations:response', recommendedProducts.listings_html);
					return;
				}

				/* Build Recommendation HTML from response
				.*-----------------------------------------*/
				dust.render(RecommendedProductsTempl, {
					products,
				}, (err, output) => {
					if (err) {
						console.error(err);
					} else {
						recommendationsHtml = output;
					}
				});

				if (recommendationsHtml) {
					rp$(document).trigger('productGetRecommendations:response', recommendationsHtml);
				}
			}
		});
	};

	product.getInventoryMessaging = function (catalog, skuStripped, inStock, price, quantity, variantMasterSku, fulfillmentHash, inventoryWarehouseId, inventoryCustomerId) {

		if (!(this.data && this.data.kit_contains_master_variant)) {
			rp$(document).trigger('productGetInventoryMessage:request');
		}

		$ajax({
			method: 'GET',
			dataType: 'json',
			data: {
				catalog: catalog,
				sku: skuStripped,
				stock: inStock,
				price: price,
				quantity: quantity,
				fulfillmentHash: fulfillmentHash,
				inventoryWarehouseId: inventoryWarehouseId,
				inventoryCustomerId: inventoryCustomerId
			},
			url: '/ajax/product/get-inventory-messaging',
			success: (message, status/*, xhr*/) => {
				if (status !== 'success') { return; }
				if (!message) { return; }
				if (this.data && this.data.kit_contains_master_variant) {
					const $rpInventoryMessage = rp$(`.rp-inventory-message-bundle.${variantMasterSku}`);
					const $rpShippingMessage = rp$(`.rp-shipping-message-bundle.${variantMasterSku}`);
					const $rpShippingEstimateMessageSection = rp$(`.rp_shipping_estimate_message_bundle.${variantMasterSku}`);
					const $shippingMessageSectionTitle = rp$('.shipping-message-title');
					const $rpShippingMessageSection = rp$(`.shipping-message-bundle-section.${variantMasterSku}`);
					const $shippingEstimateMessageHelpText = rp$('.shipping-estimate-message-helptext');
					const $rpPickupMessage = rp$(`.rp-pickup-message-bundle.${variantMasterSku}`);
					const $rpPickupMessageSection = rp$(`.pickup-message-bundle-section.${variantMasterSku}`);
					const $inventoryBundleWrap = rp$('#inventory_bundle_wrap');
					const responseInventoryMessage = getInventoryMessage(message);
					const responseShippingMessage = getShippingMessage(message);
					const responseShippingMessageTitle = getShippingMessageTitle(message);
					const responseShippingEstimateMessage = getShippingEstimateMessage(message);
					const responsePickupMessage = getPickupMessage(message);
					const responseInventoryMessageCustomerId = getInventoryMessageCustomerId(message);
					const responseInventoryMessageWarehouseId = getInventoryMessageWarehouseId(message);

					$rpInventoryMessage.html(responseInventoryMessage);
					$shippingMessageSectionTitle.html(responseShippingMessageTitle);
					$rpShippingMessage.html(responseShippingMessage);
					$rpShippingEstimateMessageSection.html(responseShippingEstimateMessage);
					$rpPickupMessage.html(responsePickupMessage);

					$inventoryBundleWrap.removeClass('inventory-out-of-stock');
					if (message.inventoryMessageType === 'OutOfStockMessagingOnly') {
						$inventoryBundleWrap.addClass('inventory-out-of-stock');
					}

					if (message.inventoryMessageType === 'StockLevel' || message.inventoryMessageType === 'InStockMessagingWithWarehouseOnly') {
						$inventoryBundleWrap.removeClass('inventory-out-of-stock');
					}

					$rpShippingMessageSection.attr('hidden', responseShippingEstimateMessage === '' && responseShippingMessage === '');
					$rpShippingMessage.attr('hidden', responseShippingMessage === '' );
					$rpShippingEstimateMessageSection.attr('hidden', responseShippingEstimateMessage === '');
					$shippingEstimateMessageHelpText.attr('hidden', responseShippingEstimateMessage === '');
					$rpPickupMessageSection.attr('hidden', responsePickupMessage === '');
					$inventoryBundleWrap.attr('hidden', responseInventoryMessage === '');

					if (responseShippingEstimateMessage !== '') {
						$rpShippingEstimateMessageSection.attr(
							'data-inventory-warehouse-id',
							responseInventoryMessageWarehouseId
						);

						$rpShippingEstimateMessageSection.attr(
							'data-inventory-warehouse-customer-id',
							responseInventoryMessageCustomerId
						);
					}

					handleZipChangeEvent();

				} else {
					rp$(document).trigger('productGetInventoryMessage:response', message);
					if (!isEmpty(fulfillmentHash)) {
						const $inventoryMessageContentEle = rp$('#rp_inventory_message');
						const $shippingMessageContentEle = rp$('#rp_shipping_message');
						const $shippingEstimateMessageContentEle = rp$('#rp_shipping_estimate_message');
						const $shippingMessageSectionTitleEle = rp$('.shipping-message-title');
						const $shippingMessageSectionEle = rp$('.shipping-message-section');
						const $shippingEstimateMessageHelpTextEle = rp$('.shipping-estimate-message-helptext');
						const $pickupMessageContentEle = rp$('#rp_pickup_message');
						const $pickupMessageSectionEle = rp$('.pickup-message-section');
						const $addToCartBtn = rp$('.product-purchase button.add-to-cart');
						const $inventoryWrap = rp$('#inventory_wrap');

						const responseInventoryMessage = getInventoryMessage(message);
						const responseShippingMessage = getShippingMessage(message);
						const responseShippingMessageTitle = getShippingMessageTitle(message);
						const responseShippingEstimateMessage = getShippingEstimateMessage(message);
						const responseInventoryMessageCustomerId = getInventoryMessageCustomerId(message);
						const responseInventoryMessageWarehouseId = getInventoryMessageWarehouseId(message);
						const responsePickupMessage = getPickupMessage(message);
						const responseInventoryType = message.inventoryMessageType ? message.inventoryMessageType : '';
						$inventoryMessageContentEle.html(responseInventoryMessage);
						$shippingMessageContentEle.html(responseShippingMessage);
						$shippingMessageSectionTitleEle.html(responseShippingMessageTitle);
						$shippingEstimateMessageContentEle.html(responseShippingEstimateMessage);
						$pickupMessageContentEle.html(responsePickupMessage);

						$addToCartBtn.attr(
							'data-inventory-message',
							responseInventoryMessage
						);
						$addToCartBtn.attr(
							'data-shipping-message',
							responseShippingMessage
						);

						$inventoryWrap.removeClass('inventory-out-of-stock');
						if (responseInventoryType === 'OutOfStockMessagingOnly') {
							$inventoryWrap.addClass('inventory-out-of-stock');
						}

						$inventoryWrap.attr('hidden', responseInventoryMessage === '');
						$shippingMessageContentEle.attr('hidden', responseShippingMessage === '');
						$shippingMessageSectionEle.attr('hidden', responseShippingMessage === '' &&  responseShippingEstimateMessage === '');
						$shippingEstimateMessageContentEle.attr('hidden', responseShippingEstimateMessage === '');
						$pickupMessageSectionEle.attr('hidden', responsePickupMessage === '');
						$shippingEstimateMessageHelpTextEle.attr('hidden', responseShippingEstimateMessage === '');

						if (responseShippingEstimateMessage !== '') {
							$shippingEstimateMessageContentEle.attr(
								'data-inventory-warehouse-id',
								responseInventoryMessageWarehouseId
							);

							$shippingEstimateMessageContentEle.attr(
								'data-inventory-warehouse-customer-id',
								responseInventoryMessageCustomerId
							);
						}

						handleZipChangeEvent();

						rp$('.change-zip-confirm').on('click', (evt) => {
							evt.preventDefault();
							const zipCode = rp$('.zip-code-input').val();
							const warehouseId = rp$('#rp_shipping_estimate_message').data('inventory-warehouse-id');
							const customerId = rp$('#rp_shipping_estimate_message').data('inventory-warehouse-customer-id');
							handleZipChange(customerId, warehouseId, zipCode);
						});
						// Update the tracking value to accurately depict what's on the page
						if (responseInventoryType && window.tracking && (typeof window.tracking.dimensions === 'object')) {
							window.tracking.dimensions.stockLevelMessaging = responseInventoryType;
						}
					}
				}
			}
		});
	};

	product.getProductOffers = function (catalog, skuStripped) {
		const $rpOfferList = rp$(`.offer-dealer-list`);
		$rpOfferList.css('min-height', '9rem');
		$rpOfferList.css('position', 'relative');
		$rpOfferList.overlaySpinner();

		const $rpOfferErrorMessage = rp$('.offers-error-message');
		if ($rpOfferErrorMessage) {
			$rpOfferErrorMessage.remove();
		}

		$ajax({
			method: 'GET',
			dataType: 'json',
			data: {
				catalog: catalog,
				sku: skuStripped,
			},
			url: '/ajax/product/get-product-offers',
			success: (response) => {
				if (!response) {
					if ($rpOfferList && $rpOfferList.overlaySpinner) {
						$rpOfferList.overlaySpinner.remove();
						$rpOfferList.css('min-height', 'auto');
					}
					return;
				}

				const offersHtml = get(response, 'offers_list_html');
				if (offersHtml) {
					if (response.offers.length === 1) {
						rp$('.change-location-form').remove();

					} else if (response.offers.length === 0) {
						$rpOfferList.css('min-height', '0');
					}

					// If we have more than one offer, we can show the msrp
					if (response.offers.length > 1) {
						rp$('.list-price-only').css('display', 'initial');
					}

					$rpOfferList.html(offersHtml);
					const accessorizerModal = rp$('#accessorizerModal');
					if (accessorizerModal && accessorizerModal.length > 0) {
						const visualizerButton = rp$('.accessory-visualizer-button');
						visualizerButton.show();
					}

					const currentPath = window.location.pathname;
					rp$('.vehiclepicker_link').each(function () {
						rp$(this).attr('data-redirect', currentPath);
					});
					rp$('.vehiclepicker_link, .vehiclepicker-link').vehiclepicker_link();

					// Attach add-to-cart on new offer
					if (typeof rp$.fn.add_to_cart === 'function') {
						rp$('.product-purchase-module').find('.add-to-cart.enabled').add_to_cart();
					}

					const $dealerSelect = rp$('.offer-dealer-list .dealer-select-button');
					if ($dealerSelect && $dealerSelect.length > 0) {
						$dealerSelect.each(function () {
							rp$(this).on('click', HandleDealerSelect);
						});
					} else {
						const $addToCartBtn = rp$('.offer-dealer-list .add-to-cart.enabled');
						if (response.offers.length === 1 && $addToCartBtn && $addToCartBtn.length > 0) {
							rp$('.product-options').on('change', '.option-select', (evt) => {
								evt.preventDefault();
								product.handleOptionChange();
							});
							const fulfillmentHash = $addToCartBtn.data('fulfillment-hash');
							const $inventoryMessageModule = rp$('.product-inventory-msg');
							if ($inventoryMessageModule.length >= 0 ) {
								const catalog = $inventoryMessageModule.data('catalog');
								const skuStripped = $inventoryMessageModule.data('sku-stripped');
								const inStock = $inventoryMessageModule.data('in-stock');
								const price = $inventoryMessageModule.data('price');
								const quantity = $inventoryMessageModule.data('quantity');
								const isVariantMaster = $inventoryMessageModule.data('is-variant-master');
								const inventoryWarehouseId = $inventoryMessageModule.data('inventory-warehouse-id');
								const inventoryCustomerId = $inventoryMessageModule.data('inventory-customer-id');
								if (catalog && skuStripped && !isVariantMaster) {
									product.getInventoryMessaging(catalog, skuStripped, inStock, price, quantity, isVariantMaster, fulfillmentHash, inventoryWarehouseId, inventoryCustomerId);
								}
							}
						}
					}
				}
			},
			error: function (error) {
				if ($rpOfferList && $rpOfferList.overlaySpinner) {
					$rpOfferList.overlaySpinner.remove();
					$rpOfferList.css('min-height', 'auto');
				}

				const errorHtml = get(error, 'responseText');
				if (errorHtml) {
					$rpOfferList.html(errorHtml);
				}
			},
		});
	};

	function HandleDealerSelect(evt) {
		evt.preventDefault();
		const dealerHash = rp$(this).data('fulfillment-hash');
		if (!dealerHash) {
			return;
		}

		$ajax({
			method: 'POST',
			dataType: 'json',
			url: '/ajax/dealers',
			data: {
				dealerHash
			},
			success: (response, status /*, xhr*/) => {
				if (status === 'success') {
					rp_app.location.reload();
				}
			}
		});
	}

	function HandleZipCodeUpdate($postalCodeInput, catalog, skuStripped) {
		const postalCode = $postalCodeInput.val();
		const $messageDiv = rp$('.change-location-form .change-location-input-error');
		if (!validatePostalCode(postalCode)) {
			$messageDiv.show();
		} else {
			$messageDiv.hide();
			$ajax({
				dataType: 'json',
				url: '/ajax/dealers',
				data: {
					postalCode,
				},
				success: (response, status /*, xhr*/) => {
					if (status === 'success') {
						product.getProductOffers(catalog, skuStripped);
					}
				}
			});
		}
	}

	/**
	 * Handle change event on option dropdowns
	 *
	 * @return {void}
	 */
	product.handleOptionChange = function () {
		const selectedOptionHashes = [];
		const selectedProductOptionHashes = {};
		const selectedProductsOptionsIdHashes = {};

		// Reset selected option value to display
		rp$('.option-display').text('');
		// Drop-down option-style: Get data of selected option
		rp$('.option-select').each((idx, optionSelectEle) => {
			let selectedOptionsIdHashes = {};
			let selectedOptionId = rp$(optionSelectEle).attr('data-option-id');
			let selectedProductSku = rp$(optionSelectEle).attr('data-option-product-sku');
			let selectedOptionHash = rp$(optionSelectEle).val();

			if (selectedOptionHash) {
				if (!get(selectedProductOptionHashes, selectedProductSku)) {
					selectedProductOptionHashes[selectedProductSku] = [];
				}
				selectedProductOptionHashes[selectedProductSku].push(selectedOptionHash);
				selectedOptionHashes.push(selectedOptionHash);

				selectedOptionsIdHashes[selectedOptionId] = selectedOptionHash;

				if (!get(selectedProductsOptionsIdHashes, selectedProductSku)) {
					selectedProductsOptionsIdHashes[selectedProductSku] = [];
				}
				selectedProductsOptionsIdHashes[selectedProductSku].push(selectedOptionsIdHashes);
				// Display selected option value
				const selectElementSelector = `.option-display-${selectedOptionId}`;
				const optionSelected = rp$(optionSelectEle).find(':selected').attr('data-option-value');
				rp$(selectElementSelector).text(optionSelected);
			}
		});

		// Button option-style: Get data of selected option
		rp$('.option-buttons button').each((idx, optionSelectedElem) => {
			let selectedOptionsIdHashes = {};
			let selectedOptionId = rp$(optionSelectedElem).attr('data-button-option-id');
			let selectedOptionHash = rp$(optionSelectedElem).attr('data-button-option-hash');
			let selectedProductSku = rp$(optionSelectedElem).attr('data-button-product-sku');
			// Reset disabled buttons
			rp$(optionSelectedElem).attr('disabled', false);
			if (rp$(optionSelectedElem).hasClass('selected')) {
				if (selectedOptionHash) {
					if (!get(selectedProductOptionHashes, selectedProductSku)) {
						selectedProductOptionHashes[selectedProductSku] = [];
					}
					selectedProductOptionHashes[selectedProductSku].push(selectedOptionHash);
					selectedOptionHashes.push(selectedOptionHash);

					selectedOptionsIdHashes[selectedOptionId] = selectedOptionHash;
				}

				if (!get(selectedProductsOptionsIdHashes, selectedProductSku)) {
					selectedProductsOptionsIdHashes[selectedProductSku] = [];
				}
				selectedProductsOptionsIdHashes[selectedProductSku].push(selectedOptionsIdHashes);
				// Display selected option value
				const displayElementClass = `.option-display-${selectedOptionId}`;
				const optionSelectedVal = rp$(optionSelectedElem).attr('value');
				rp$(displayElementClass).text(optionSelectedVal);
			}
		});

		// Check settings for option on change required
		if (this.data.hide_option_without_variant && Object.keys(this.data.all_product_variants).length > 0) {
			this.rebuildOptionValuesBasedOnSelection(selectedProductsOptionsIdHashes);
		}

		/* Handle Selected Options
		.*-----------------------------------------*/
		// Set selected hashes on the add-to-cart button
		this.$addToCartBtn.data('options', selectedOptionHashes.join(','));
		// Find variant product that matches the selected options
		if (this.data.kit_contains_master_variant) {
			this.buildBundleVariants(selectedProductOptionHashes, selectedProductsOptionsIdHashes);
		} else {
			const variant = this.matchOptionsToVariant(selectedOptionHashes);

			if (variant) {
				if (this.handleProductAvailability(variant.product)) {
					// Update Title
					rp$('.product-title').html(variant.product.title);
					// Fetch Product Info
					this.fetchProduct(variant.product);
				}
			} else {
				if (this.handleProductAvailability(this.data)) {
					// Update Title
					rp$('.product-title').html(this.data.title);
					// Update Product Info
					this.handleProductChanges(this.data);
				}
			}

			// Build Price/MSRP from selected options
			const pricing = this.buildPricingFromOptions(selectedOptionHashes, variant);
			this.buildOptionsPriceModifier(pricing);

			/* Build non-price information from target product
			.*-----------------------------------------*/
			this.displayProductPrice(pricing.price, pricing.msrp);
		}
	};

	/**
	 * Find a variant that matches the selected option hashes
	 *
	 * @param  {array} selectedOptionHashes Array of MD5 hashes for the selected options
	 * @return {object|null} variant product, or null if nothing is found
	 */
	product.matchOptionsToVariant = function (selectedOptionHashes) {
		if (!Array.isArray(this.data.variants)) { return null; }
		if (!Array.isArray(selectedOptionHashes)) { return null; }
		if (selectedOptionHashes.length === 0) { return null; }

		/* Find Variant Matching selected values
		.*-----------------------------------------*/
		const matchingVariant = this.data.variants.find((variant) => {
			let variantOptionsMatch = true;
			variant.options.forEach((variantOption) => {
				if (!selectedOptionHashes.includes(variantOption)) {
					variantOptionsMatch = false;
				}
			});
			return (variantOptionsMatch === true);
		});

		return (matchingVariant) ? matchingVariant : null;
	};

	product.buildBundleVariants = function (selectedProductsOptionsHashes, selectedProductsOptionsIdHashes) {
		const allProductVariants = this.data.all_product_variants;
		const allProductDetails = this.data.all_product_details;
		const productOptionValues = this.productOptionValues;

		const $inventoryWrap = rp$('#inventory_bundle_wrap');
		$inventoryWrap.removeClass('hide');

		Object.keys(this.bundleDetails).forEach(productSku => {
			const $titleSelector = rp$(`.product-bundle-title.${productSku}`);
			const productOptionHashes = get(selectedProductsOptionsHashes, productSku);
			let productDetails = allProductDetails[productSku];

			if (productOptionHashes) {
				const variantHashkey = this.getSelectedProductToVariantKey(productOptionHashes);
				const productVariants = get(allProductVariants, productSku);
				const variant = get(productVariants, variantHashkey);
				if (variant) {
					productDetails = variant.product;
				}
			}

			let modifierPrice = 0.00;
			const productOptionsIdHashes = get(selectedProductsOptionsIdHashes, productSku);
			if (productOptionsIdHashes) {
				productOptionsIdHashes.forEach((optionsIdHash) => {
					Object.keys(optionsIdHash).map(function (optionId) {
						const optionValList = get(productOptionValues, optionId);
						optionValList.forEach((optionVal) => {
							if (optionVal['hash'] === optionsIdHash[optionId]) {
								let modifier = optionVal.price_modifier;
								if (modifier) {
									modifierPrice += product.getProductPriceModifier(modifier, productDetails.price);
								}
							}
						});
					});
				});
			}

			$titleSelector.html(productDetails.title);
			this.bundleDetails[productSku].sku_stripped = productDetails.sku_stripped;
			this.bundleDetails[productSku].price = productDetails.price + modifierPrice;
			this.bundleDetails[productSku].catalog = productDetails.catalog;
			this.bundleDetails[productSku].title = productDetails.title;

			this.refreshStockMessagingForBundleProduct(productDetails, productSku);
		});

		this.updateBundleProductPrice();
	};

	product.getProductPriceModifier = function (modifier, productPrice) {
		let modifierPrice = 0.00;
		modifier.value = Number(modifier.value);
		if (!isNaN(modifier.value)) {
			if (modifier.type === 'AMT') {
				// Amount: Add value to the base values
				modifierPrice += Number(modifier.value.toFixed(2));
			} else if (modifier.type === 'PCT') {
				// Percentage: Calculate value and append to base values
				const pctValue = modifier.value / 100;
				const priceModifier = productPrice * pctValue;
				modifierPrice += Number(priceModifier.toFixed(2));
			}
		}
		return Number(modifierPrice.toFixed(2));
	};

	product.updateBundleProductPrice = function () {
		const bundleDetails = this.bundleDetails;
		const addToCartDataValues = [];
		let totalPrice = 0.00;

		Object.keys(bundleDetails).forEach(productSku => {
			let price = bundleDetails[productSku].price * bundleDetails[productSku].quantity;
			const addToCartData = this.bundleDetails[productSku].sku_stripped + '|' + this.bundleDetails[productSku].catalog + '|' + this.bundleDetails[productSku].quantity + '|' + price;
			addToCartDataValues.push(addToCartData);
			totalPrice = totalPrice + price;
		});

		const $salePriceRow = rp$('.product-price .sale-price');
		const currencyCode = this.$addToCartBtn.data('currencyCode');
		$salePriceRow.find('.sale-price-value').html(window.rp_app.priceFormat(totalPrice, currencyCode));

		this.$addToCartBtn.data('component-skus-stripped', addToCartDataValues.join(','));
	};

	function buildOptionWithPrice(optionEle, optionValues, pricing, optionAttr) {
		const $optionElem = rp$(optionEle);
		const optionHash = $optionElem.attr(optionAttr);
		const option = optionValues.find((value) => {
			return (value.hash === optionHash);
		});

		if (option) {
			const priceDelta = option.modified_price - pricing.price;
			const optionLabel = buildOptionLabel(option.label, priceDelta, option.disabled);
			$optionElem.html(optionLabel);
		}
	}

	function buildOptionLabel(label, priceDelta, disabled) {

		let optionLabel = label;

		// Option Price Delta
		if (priceDelta !== 0) {
			const deltaDisplay = window.rp_app.priceFormat(Math.abs(priceDelta));
			const deltaPlusMinus = (priceDelta > 0) ? '+' : '-';
			optionLabel = `${optionLabel} ${deltaPlusMinus}${deltaDisplay}`;
		}

		// Option Disabled
		if (disabled) {
			optionLabel = `${optionLabel} - Not available for current selection`;
		}

		return optionLabel;
	}

	product.buildOptionsPriceModifier = function (pricing) {
		const optionLength = rp$('.option-select').length + rp$('.option-buttons').length;

		// Don't display price difference if there are more than one option
		if (optionLength > 1) { return; }

		rp$('.option-select').find('option').each((idx, optionEle) => {
			buildOptionWithPrice(optionEle, this.optionValues, pricing, 'value');
		});

		rp$('.option-buttons').find('button').each((idx, optionEle) => {
			buildOptionWithPrice(optionEle, this.optionValues, pricing, 'data-button-option-hash');
		});
	};

	product.rebuildOptionValuesBasedOnSelection = function (selectedProductsOptionsIdHashes)
	{
		let disabledOptions = {};
		const selectedOptionsHashes = {};

		// Generate related option list for selected option
		if (typeof selectedProductsOptionsIdHashes === 'object' && Object.keys(selectedProductsOptionsIdHashes).length > 0) {
			// For Every Selected Option, build the Selected and Disabled hashes
			Object.keys(selectedProductsOptionsIdHashes).forEach((productSku) => {
				selectedProductsOptionsIdHashes[productSku].forEach((selectedOptionsIdHash) => {
					Object.keys(selectedOptionsIdHash).forEach((optionId) => {
						// At this point we have an Product / Selected Option Hash / Option ID combo
						// Set selected option hashes for rebuild
						selectedOptionsHashes[optionId] = selectedOptionsIdHash[optionId];
					});
				});

				const skuProductOptions = get(this.data.all_product_options, productSku) || [];

				disabledOptions = {
					...disabledOptions,
					...product.buildDisabledOptions(skuProductOptions, selectedOptionsHashes),
				};
			});
		}

		// Rebuild Product Option Values
		product.rebuildOptionValues(this.data.all_product_options, selectedOptionsHashes, disabledOptions);
	};

	/**
	 * build a list of options that should be disabled based on selection
	 *
	 * @param {array} allProductOptions
	 * @param {object} selectedOptionsHashes object containing optionId to selectedHash Pairs
	 * @returns {object} object containing optionId to selectedHash Pairs
	 */
	product.buildDisabledOptions = function (allProductOptions, selectedOptionsHashes)
	{
		const disabledOptions = {};
		const unselectedProductOptions = allProductOptions.filter(option => {
			return !selectedOptionsHashes.hasOwnProperty(option.id);
		});

		// If we have more than one unselected option, we don't have enough information to build variants
		if (unselectedProductOptions.length > 1) {
			return disabledOptions;
		}

		// for each option, go through and make a matrix of other options
		// if all other options are selected, loop through option values of target and find variants
		allProductOptions.forEach(targetOption => {
			const targetOptionId = targetOption.id;

			// grab all other selected options
			const otherSelectedOptions = allProductOptions.filter((option) => {
				const notTargetOption = option.id !== targetOptionId;
				const optionIsSelected = selectedOptionsHashes.hasOwnProperty(option.id);
				return notTargetOption && optionIsSelected;
			});

			// We have enough data to evaluate variant combinations
			if (otherSelectedOptions.length + 1 === allProductOptions.length) {
				if (!disabledOptions.hasOwnProperty(targetOption.id)) {
					disabledOptions[targetOptionId] = [];
				}

				const otherSelectedHashes = otherSelectedOptions.map(option => {
					return selectedOptionsHashes[option.id];
				});
				const targetOptionValues = get(targetOption, 'values') || [];
				targetOptionValues.forEach(optionValue => {
					const valueHash = optionValue.hash;

					const combinationVariantSku = product.getVariantSkuFromSelectedOptions([
						valueHash,
						...otherSelectedHashes
					]);

					if (product.shouldDisableVariantOption(combinationVariantSku)) {
						disabledOptions[targetOptionId].push(valueHash);
					}
				});
			}
		});

		return disabledOptions;
	};

	/**
	 * Find a variant from a collection of
	 * @param {array} selectedHashes array of selected hash strings
	 * @returns {object|null}
	 */
	product.getVariantSkuFromSelectedOptions = function (selectedHashes)
	{
		const variantHashkey = this.getSelectedProductToVariantKey(selectedHashes);
		const optionsToVariantsMap = this.getOptionsToVariantSkuHashmap();
		return optionsToVariantsMap[variantHashkey];
	};

	/**
	 * Build a hashmap key for selected-hashes-to-variant-sku lookup
	 * @TODO: This is slightly unsafe, needs to use main product sku-stripped as well
	 *
	 * @param {array} selectedHashes array of selected hash strings
	 * @returns {string}
	 */
	product.getSelectedProductToVariantKey = function (selectedHashes)
	{
		if (!Array.isArray(selectedHashes)) {
			return '';
		}
		const combinationHash = selectedHashes.sort().join('-');
		return combinationHash;
	};

	/**
	 * Return hashmap of selected options to keyes
	 * NOTE: Depends on local this.data.variants
	 * @TODO: Could this be completely supplied by the server?
	 * @returns {object} hashmap from selected-option-keys to variant sku
	 */
	product.getOptionsToVariantSkuHashmap = function ()
	{
		if (this.data.options_to_variants_map) {
			return this.data.options_to_variants_map;
		}
		this.data.options_to_variants_map = {};
		this.data.variants.forEach(variant => {
			const options = get(variant, 'options') || [];
			const variantSku = get (variant, 'product.sku_stripped');
			if (variantSku && options.length > 0) {
				const key = product.getSelectedProductToVariantKey(options);
				this.data.options_to_variants_map[key] = variantSku;
			}
		});
		return this.data.options_to_variants_map;
	};

	/**
	 * Get Variant Availability Constant (human readable, english)
	 * NOTE: Depends on local this.data.all_product_availabilty
	 *
	 * @param {string} variantSku
	 * @returns {string|null} Variant availability object
	 */
	product.getVariantAvailability = function (variantSku)
	{
		const productAvailability = this.data.all_product_availabilty;
		const variantAvailability = get(productAvailability, `${variantSku}.availability`);
		return variantAvailability;
	};

	/**
	 * Return whether or not This variant option should be disabled
	 * NOTE: Depends on this.data.hide_option_if_no_variant
	 *
	 * @param {string} variantSku
	 * @returns {boolean}
	 */
	product.shouldDisableVariantOption = function (variantSku)
	{
		let shouldDisableVariantOption = false;
		const variantAvailability = product.getVariantAvailability(variantSku);
		const hideOptionWithoutVariant = this.data.hide_option_without_variant;

		if (!variantSku && hideOptionWithoutVariant) {
			shouldDisableVariantOption = true;
		} else if (variantAvailability && variantAvailability !== AVAILABILITY.available_for_sale) {
			shouldDisableVariantOption = true;
		}

		return shouldDisableVariantOption;
	};

	/**
	 * Rebuild the option selection UI on the page
	 *
	 * @param {object} allOptions all product options, by sku
	 * @param {object} selectedOptions
	 * @param {object} disabledOptions
	 * @returns {void} // Updates DOM
	 */
	product.rebuildOptionValues = function (allOptions, selectedOptions, disabledOptions)
	{
		if (typeof allOptions !== 'object' || allOptions === null) {
			return;
		}

		// Build options array from allOptions
		let options = [];
		for (const skuStripped in allOptions) {
			const productOptions = allOptions[skuStripped];
			if (Array.isArray(productOptions)) {
				options = [...options, ...productOptions];
			}
		}

		options.forEach(option => {
			const optionId = option.id;
			const selectedHash = get(selectedOptions, optionId);
			const disabledHashes = get(disabledOptions, optionId);

			const selectElementSelector = `.option-select[data-option-id=${optionId}]`;
			const $selectElem = rp$(selectElementSelector);

			if (option.optionStyle === 'BUTTONS') {
				if (disabledHashes) {
					disabledHashes.forEach((hash) => {
						let buttonId = `#${optionId}_${hash}`;
						const $buttonElem = rp$(buttonId);
						$buttonElem.attr(OPTION_ATTRIBUTES.disabled, true);
					});
				}
			} else {
				// Empty $selectElem
				$selectElem.html('');

				// Set default option
				const $initialOptionValueElem = rp$('<option></option>');
				// @TODO localize
				const optionLabel = 'Select ' + option.label;
				$initialOptionValueElem
					.attr(OPTION_ATTRIBUTES.value, '')
					.text(optionLabel);
				$selectElem.append($initialOptionValueElem);

				// Generate Options
				option.values.forEach((value) => {
					const $optionValueElem = rp$('<option></option>');

					$optionValueElem
						.attr(OPTION_ATTRIBUTES.value, value.hash)
						.attr(OPTION_ATTRIBUTES.data_option_value, value.label);

					// Checking for selected option
					$optionValueElem.attr(OPTION_ATTRIBUTES.selected, value.hash === selectedHash);

					// For single-option variants, rely on the disabled field coming from the options
					let valueDisabled = value.disabled;
					// disabledHashList contains the list of option hashes that are invalid given the current selection
					if (disabledHashes && disabledHashes.includes(value.hash)) {
						valueDisabled = true;
					}

					if (valueDisabled) {
						$optionValueElem.attr(OPTION_ATTRIBUTES.disabled, true);
					}

					const optionLabel = buildOptionLabel(value.label, 0, valueDisabled);
					$optionValueElem.html(optionLabel);

					// Add option to $selectElem
					$selectElem.append($optionValueElem);
				});
			}
		});
	};

	/**
	 * Build price/MSRP information from selected options
	 *
	 * @param  {array} selectedOptionHashes Array of MD5 hashes for the selected options
	 * @return {object} Object containing price/MSRP values
	 */
	product.buildPricingFromOptions = function (selectedOptionHashes, variant) {
		const variantProduct = (isObjectLike(variant)) ? variant.product : null;

		/* Build Initial Price / MSRP
		.*-----------------------------------------*/
		let useVariantPricing = false;
		let basePrice = this.data.price;
		let baseMsrp = this.data.msrp;
		// If in variant context, variant pricing is the new base
		if (variantProduct && variantProduct.source === 'product' && (variantProduct.price || variantProduct.msrp)) {
			basePrice = variantProduct.price || basePrice;
			baseMsrp = variantProduct.msrp || baseMsrp;
			useVariantPricing = true;
		}
		// Sanitize Inputs and set up pricing object
		basePrice = Number(basePrice);
		baseMsrp = Number(baseMsrp);
		if (Number.isNaN(basePrice)) { basePrice = 0; }
		if (Number.isNaN(baseMsrp)) { baseMsrp = 0; }
		let pricing = {
			price: basePrice,
			msrp: baseMsrp
		};

		/* If variant pricing is returned, no need to calculate
		.*-----------------------------------------*/
		if (useVariantPricing === true) { return pricing; }

		/* If no options exist, then we're done
		.*-----------------------------------------*/
		if (!Array.isArray(this.data.options)) { return pricing; }

		/* Pull value objects from selected hashes
		.*-----------------------------------------*/
		const selectedOptionValues = selectedOptionHashes.map((selectedOptionHash) => {
			return this.optionValues.find((value) => {
				return (value.hash === selectedOptionHash);
			});
		});

		/* Modify Price / MSRP from selected values
		.*-----------------------------------------*/
		selectedOptionValues.forEach((optionValue) => {
			// Abort if we don't have a valid price modifier
			let modifier = optionValue.price_modifier;
			if (!modifier) { return; }
			modifier.value = Number(modifier.value);
			if (isNaN(modifier.value)) { return; }

			// TODO: If variants prices include the modifiers from their options,
			// then we want to skip options that are included at at this point, and
			// DO NOT add those modifiers to the variant price
			// if(variant && Array.isArray(variant.options) && variant.options.includes(optionValue.hash)) {
			// 	return;
			// }
			// TODO: If this is the case, uncomment the above

			if (modifier.type === 'AMT') {
				// Amount: Add value to the base values
				pricing.price += modifier.value;
				if (baseMsrp) {
					pricing.msrp += modifier.value;
				}
			} else if (modifier.type === 'PCT') {
				// Percentage: Calculate value and append to base values
				let pctValue = modifier.value / 100;
				let priceModifier = basePrice * pctValue;
				pricing.price += Number(priceModifier.toFixed(2));

				if (baseMsrp) {
					let msrpModifier = baseMsrp * pctValue;
					pricing.msrp += Number(msrpModifier.toFixed(2));
				}
			}
		});

		pricing.price = Number(pricing.price.toFixed(2));
		pricing.msrp = (baseMsrp) ? Number(pricing.msrp.toFixed(2)) : 0;
		return pricing;
	};

	product.handleProductAvailability = function (targetProduct) {
		const all_product_availabilty = this.data.all_product_availabilty;
		const product_availability = get(all_product_availabilty, targetProduct.sku_stripped);
		// Refresh the page if product availabilty option changed for master and variant product
		if (check_product_availability === null && typeof product_availability === 'object' && this.data.current_product_availabilty !== product_availability.availability) {
			rp$('.product-purchase-module').addClass('loading');
			check_product_availability = product_availability.availability;
			let baseUrl = rp$('base').attr('href');
			if (!baseUrl || typeof baseUrl === 'string') {
				baseUrl = rp_app.location.getBase();
			}
			const nextPath = baseUrl + product_availability.product_url;
			window.location.href = nextPath;
			return false;
		}
		return true;
	};

	product.fetchProduct = function (targetProduct) {
		if (typeof targetProduct !== 'object') { return; }
		const catalog = targetProduct.catalog;
		const skuStripped = targetProduct.sku_stripped;
		if (!catalog || !skuStripped) { return; }

		rp$('.product-purchase-module').addClass('loading');

		window.rp_app.request({
			method: 'POST',
			dataType: 'json',
			url: `/ajax/product/get-product/${catalog}/${skuStripped}`,
			success: (response/*, status, xhr*/) => {
				rp$('.product-purchase-module').removeClass('loading');
				if (!response) { return; }

				if (response.product) {
					this.handleProductChanges(response.product);
					if (response.product.source === 'product') {
						this.displayProductPrice(response.product.price, response.product.msrp);
					}
				}
			},
			error: () => {
				rp$('.product-purchase-module').removeClass('loading');
			}
		});
	};

	/**
	 * Update the availability message
	 *
	 * @param  {object} targetProduct Object representing the currently-selected product
	 * @return {void}
	 */
	product.updateAvailabilityMessage = function (targetProduct) {
		const all_product_availabilty = this.data.all_product_availabilty;
		const product_availability = get(all_product_availabilty, targetProduct.sku_stripped);

		const $cannotPurchaseEle = rp$('.cannot-purchase');
		if ($cannotPurchaseEle.length > 0) {
			$cannotPurchaseEle.remove();
		}

		const $productPurchaseEle = rp$('.product-purchase');
		this.$addToCartBtn.hide();
		switch (product_availability.availability) {
			case AVAILABILITY.available_for_sale:
				this.$addToCartBtn.show();
				break;
			case AVAILABILITY.discontinued:
				$productPurchaseEle.append('<div class="cannot-purchase discontinued-part"><h3>' + window.javascriptContent.discontinued_part + '</h3><p>' + window.javascriptContent.discontinued_part_message + '</p></div>');
				break;
			case AVAILABILITY.not_for_sale:
				$productPurchaseEle.append('<div class="cannot-purchase not-for-sale-item"><h3>' + window.javascriptContent.not_for_sale + '</h3><p>' + window.javascriptContent.discontinued_part_message + '</p></div>');
				break;
			case AVAILABILITY.on_backorder:
				$productPurchaseEle.append('<div class="cannot-purchase"><h3>' + window.javascriptContent.backordered_part + '</h3><p>' + window.javascriptContent.backordered_part_message + '</p></div>');
				break;
			case AVAILABILITY.call_for_price:
				$productPurchaseEle.append('<div class="cannot-purchase ship-controlled-item"><h3><a href="/contact-us?type=contact_for_price&product_page=' + encodeURI(targetProduct.title) + '" class="contact-link"> <i class="fa fa-envelope"></i> ' + window.javascriptContent.call_for_price + '</a></h3></div>');
				break;
			case AVAILABILITY.call_for_availability:
				$productPurchaseEle.append('<div class="cannot-purchase ship-controlled-item"><h3><a href="/contact-us?type=contact_for_availability&product_page=' + encodeURI(targetProduct.title) + '" class="contact-link"> <i class="fa fa-envelope"></i> ' + window.javascriptContent.call_for_availability + '</a></h3></div>');
				break;
			default:
				this.$addToCartBtn.show();
				break;
		}
	};

	/**
	 * Handle non-price-related changes to a given product
	 *
	 * @param  {object} targetProduct Object representing the currently-selected product
	 * @return {void}
	 */
	product.handleProductChanges = function (targetProduct) {
		// Refresh Product Availability Message
		// TODO - skip this for now, we could potentially use this if "can purchase" doesn't change
		//product.updateAvailabilityMessage(targetProduct);

		// Refresh Product Stock Messaging
		product.refreshStockMessaging(targetProduct);
		let currentSkuStripped = String(this.$addToCartBtn.data('sku-stripped'));
		if (currentSkuStripped === 'undefined') {
			currentSkuStripped = get(window.tracking, 'products[0].product_id');
		}
		// if new product is the same, we're done
		if (targetProduct.sku_stripped === currentSkuStripped) { return; }

		/* Update SKU
		.*-----------------------------------------*/
		rp$('.sku-display').html(targetProduct.sku);
		rp$('.sku-stripped-value').val(targetProduct.sku_stripped);
		this.$addToCartBtn.data('sku', targetProduct.sku);
		this.$addToCartBtn.data('sku-stripped', targetProduct.sku_stripped);
		this.$addToCartBtn.data('catalog', targetProduct.catalog);

		/* Update Fitment HTML
		.*-----------------------------------------*/
		let expandLimit = 4;
		let hasTrimEngines = false;
		const fitmentInfo = (targetProduct.fitment || []).map((fitment) => {
			if (fitment.trims && fitment.engines) {
				hasTrimEngines = true;
			}
			fitment.trims = fitment.trims || [];
			fitment.engines = fitment.engines || [];
			fitment.idx = fitment.idx || 0;

			if (Array.isArray(fitment.trims)) {
				fitment.trims = fitment.trims.join(', ');
			}
			if (Array.isArray(fitment.engines)) {
				fitment.engines = fitment.engines.join(', ');
			}

			fitment.hidden = (fitment.idx >= expandLimit);
			return fitment;
		});
		let productFitmentHtml;
		const fitmentData = {
			hasFitmentInfo: (fitmentInfo.length > 0) && !this.data.universal_fitment,
			fitment: fitmentInfo,
			closed: (fitmentInfo.length > expandLimit),
			content: this.data.content,
			hasTrimEngines: hasTrimEngines,
		};
		fitmentData.content.fitment.this_product_fits = rp$('.product-fitment-title').html();
		// Render Template
		dust.render(ProductFitmentTempl, fitmentData, (err, output) => {
			if (err) {
				console.error(err);
			} else {
				productFitmentHtml = output;
			}
		});
		rp$(document).trigger('setProductFitment:html', productFitmentHtml);

		/* Update Product Details
		.*-----------------------------------------*/
		// Only display product description if it has been updated (or if master is empty)
		let displayDescription = this.data.description;
		if (!displayDescription || targetProduct.description_updated) {
			displayDescription = targetProduct.description;
		}
		let productDetailsHtml = null;
		const detailsData = {
			in_rp_catalog: targetProduct.in_rp_catalog,
			catalog: targetProduct.catalog,
			sku: targetProduct.sku,
			hasDetails: (!!targetProduct.also_known_as || !!targetProduct.positions || !!targetProduct.description || !!targetProduct.footnotes || !!targetProduct.applications || !!targetProduct.manufacturer),
			also_known_as: targetProduct.also_known_as,
			positions: targetProduct.positions,
			description: displayDescription,
			footnotes: targetProduct.footnotes,
			applications: targetProduct.applications,
			content: this.data.content,
		};
		// Render Template
		dust.render(ProductDetailsTempl, detailsData, (err, output) => {
			if (err) {
				console.error(err);
			} else {
				productDetailsHtml = output;
			}
		});
		if (productDetailsHtml !== null) {
			rp$(document).trigger('setProductDetails:html', productDetailsHtml);
		}

		/* Update Images HTML
		.*-----------------------------------------*/
		if (!Array.isArray(targetProduct.images)) { targetProduct.images = []; }
		if (!Array.isArray(this.data.images)) { this.data.images = []; }
		let productImagesHtml;
		let targetImages = (targetProduct.images.length > 0) ? targetProduct.images : this.data.images;
		let mainImage = (targetImages.length > 0) ? targetImages[0] : null;
		const makeLogo = (mainImage && mainImage.type === 'make_part_source') ? mainImage : null;
		// If we just have a make logo, switch to "no images"
		if (targetImages.length === 1 && makeLogo) {
			targetImages = [];
			mainImage = null;
		}
		dust.render(ProductImagesTempl, {
			mainImage: mainImage,
			hasImages: (targetImages.length > 0),
			showThumbScroll: (targetImages.length > 3),
			imagesScroll: (targetImages.length < 5),
			hasSecondaryImages: (targetImages.length > 1),
			images: targetImages,
			makeLogo: makeLogo,
			content: this.data.content
		}, (err, output) => {
			if (err) {
				console.error(err);
			} else {
				productImagesHtml = output;
			}
		});
		// Update Images Modules
		if (productImagesHtml) {
			rp$(document).trigger('setProductImages:html', productImagesHtml);
		}

		/* Update Image on add-to-cart
		.*-----------------------------------------*/
		let cartImage = null;
		if (mainImage) {
			const imgSizePrefs = ['thumb', 'preview', 'main'];
			imgSizePrefs.forEach((imgSize) => {
				let sizeImage = mainImage[imgSize] || null;
				if (!cartImage && sizeImage) {
					cartImage = sizeImage;
				}
			});
		}
		if (cartImage) {
			this.$addToCartBtn.data('image-url', cartImage.url);
			this.$addToCartBtn.data('image-type', cartImage.type);
		} else {
			this.$addToCartBtn.data('image-url', null);
			this.$addToCartBtn.data('image-type', null);
		}
	};

	/**
	 * Refresh product stock messaging on the page
	 * @param {object} targetProduct Object representing the currently-selected product
	 * @return {void}
	 */
	product.refreshStockMessaging = (targetProduct) => {
		// Do not display stock if master product and it cannot be added to cart
		let displayStockMessaging = true;
		const $addToCartBtn = rp$('.product-purchase button.add-to-cart');
		if (targetProduct.source === 'product' && targetProduct.variants && targetProduct.variants.length) {
			// Check if all mandatory options are selected for option-style: Drop-down
			const $requiredOptionSelects = rp$('#page-product .product-purchase-module').find('.option-select.option-required');
			$requiredOptionSelects.each((idx, element) => {
				const selectedOptionHash = rp$(element).val();
				if (!selectedOptionHash) {
					displayStockMessaging = false;
				}
			});
			// Check if all mandatory options are selected for option-style: Button
			const $requiredButtonOptionSelects = rp$('#page-product .product-purchase-module').find('.option-buttons.option-required');
			$requiredButtonOptionSelects.each((idx, element) => {
				const $buttonSelected = rp$(element).find('button.selected');
				if ($buttonSelected.length === 0) {
					displayStockMessaging = false;
				}
			});
		}

		if (displayStockMessaging && $addToCartBtn && $addToCartBtn.length > 0) {
			const inStock = targetProduct.quantity > 0 || targetProduct.pdc_quantity > 0;
			const fulfillmentHash = $addToCartBtn.data('fulfillment-hash');
			product.getInventoryMessaging(targetProduct.catalog, targetProduct.sku_stripped, Number(inStock), targetProduct.price, targetProduct.quantity, null, fulfillmentHash, targetProduct.inventory_warehouse_id, targetProduct.inventory_customer_id);
			$addToCartBtn.data('in-stock', Number(inStock));
		} else {
			const $inventoryWrap = rp$('#inventory_wrap');
			$inventoryWrap.attr('hidden', true);
		}
	};

	product.refreshStockMessagingForBundleProduct = (targetProduct, productSku) => {
		// Do not display stock if master product and it cannot be added to cart
		let displayStockMessaging = true;
		const $addToCartBtn = rp$('.product-purchase button.add-to-cart');
		if (targetProduct.source === 'product' && targetProduct.variants && targetProduct.variants.length) {
			// Check if all mandatory options are selected for option-style: Drop-down
			const $requiredOptionSelects = rp$('#page-product .product-purchase-module').find(`.option-select.${productSku}.option-required`);
			$requiredOptionSelects.each((idx, element) => {
				const selectedOptionHash = rp$(element).val();
				if (!selectedOptionHash) {
					displayStockMessaging = false;
				}
			});
			// Check if all mandatory options are selected for option-style: Button
			const $requiredButtonOptionSelects = rp$('#page-product .product-purchase-module').find(`.option-buttons.${productSku}.option-required`);
			$requiredButtonOptionSelects.each((idx, element) => {
				const $buttonSelected = rp$(element).find('button.selected');
				if ($buttonSelected.length === 0) {
					displayStockMessaging = false;
				}
			});
		}

		const $rpInventoryMessage = rp$(`.rp-inventory-message-bundle.${productSku}`);
		const $rpShippingMessage = rp$(`.rp-shipping-message-bundle.${productSku}`);
		const $rpPickupMessage = rp$(`.rp-pickup-message-bundle.${productSku}`);
		const $rpShippingEstimateMessage = rp$(`.rp_shipping_estimate_message_bundle.${productSku}`);
		$rpInventoryMessage.html('');
		$rpShippingMessage.html('');
		$rpShippingEstimateMessage.html('');
		$rpPickupMessage.html('');

		if (displayStockMessaging && $addToCartBtn && $addToCartBtn.length > 0) {
			const inStock = targetProduct.quantity > 0 || targetProduct.pdc_quantity > 0;
			const fulfillmentHash = $addToCartBtn.data('fulfillment-hash');
			product.getInventoryMessaging(targetProduct.catalog, targetProduct.sku_stripped, Number(inStock), targetProduct.price, targetProduct.quantity, productSku, fulfillmentHash, targetProduct.inventory_warehouse_id, targetProduct.inventory_customer_id);
		} else {
			const $inventoryWrap = rp$('#inventory_bundle_wrap');
			$inventoryWrap.addClass('hide');
		}
	};

	/**
	 * Update price and MSRP information on the page
	 *
	 * @param  {number} price Product Price
	 * @param  {number} msrp Product MSRP"
	 * @return {void}
	 */
	product.displayProductPrice = function (price, msrp) {
		// Input handling
		if (typeof price !== 'number') {
			price = parseFloat(price);
			if (isNaN(price)) { price = 0; }
		}
		if (typeof msrp !== 'number') {
			msrp = parseFloat(msrp);
			if (isNaN(msrp)) { msrp = 0; }
		}
		if (price === 0) {
			return; // If price is 0, something is wrong. Bail
		}

		/* Calculate Savings
		.*-----------------------------------------*/
		let savingsAmount = 0;
		let savingsPercent = 0;
		if (price && msrp) {
			savingsAmount = msrp - price;
			savingsPercent = (savingsAmount / msrp) * 100;
			savingsAmount = Number(savingsAmount.toFixed(2));
			savingsPercent = Number(savingsPercent.toFixed(1));
		}

		const $addToCartBtn = rp$('.product-purchase button.add-to-cart');
		const currencyCode = $addToCartBtn.data('currencyCode');

		// Update List Price
		const $listPriceRow = rp$('.product-price .list-price');
		if (price >= msrp) {
			$listPriceRow.hide();
		} else {
			$listPriceRow.show();
			$listPriceRow.find('.list-price-value').html(window.rp_app.priceFormat(msrp, currencyCode));
			$addToCartBtn.data('msrp', msrp);
		}

		// Update Savings AmountValue
		const $savingsRow = rp$('.product-price .you-save');
		if (savingsAmount <= 0) {
			$savingsRow.hide();
		} else {
			$savingsRow.show();
			$savingsRow.find('.savings-amount-value').html(window.rp_app.priceFormat(savingsAmount, currencyCode));
			$savingsRow.find('.savings-percent-value').html(NumberFormat.percentage(savingsPercent));
		}

		// Update Price Value
		const $salePriceRow = rp$('.product-price .sale-price');
		$salePriceRow.find('.sale-price-value').html(window.rp_app.priceFormat(price, currencyCode));
		$addToCartBtn.data('sale-price', price);
	};

	function switchClass(elem, addClassName, removeClassName) {
		if (removeClassName && rp$(elem).hasClass(removeClassName)) {
			rp$(elem).removeClass(removeClassName);
		}
		rp$(elem).addClass(addClassName);
	}

	$onReady({
		rp$, window,
		label: 'product',
		fn: function () {
			check_product_availability = null;
			let $inventoryMessageModule = rp$('.product-inventory-msg');
			if ($inventoryMessageModule.length > 0) {
				let catalog = $inventoryMessageModule.data('catalog');
				let skuStripped = $inventoryMessageModule.data('sku-stripped');
				let inStock = $inventoryMessageModule.data('in-stock');
				let price = $inventoryMessageModule.data('price');
				let quantity = $inventoryMessageModule.data('quantity');
				let isVariantMaster = $inventoryMessageModule.data('is-variant-master');
				let inventoryWarehouseId= $inventoryMessageModule.data('inventory-warehouse-id');
				let inventoryCustomerId= $inventoryMessageModule.data('inventory-customer-id');

				if (catalog && skuStripped && !isVariantMaster) {
					product.getInventoryMessaging(catalog, skuStripped, inStock, price, quantity, null, null, inventoryWarehouseId, inventoryCustomerId);
				}
			}

			/* Pull Recommendations
			.*-----------------------------------------*/
			var $recommendationModule = rp$('.product-recommended-module .product-recommendations');
			if ($recommendationModule.length > 0) {
				let catalog = $recommendationModule.data('catalog');
				let skuStripped = $recommendationModule.data('sku-stripped');
				let limit = $recommendationModule.data('recommendation-limit');
				let displayList = $recommendationModule.data('display-list');
				if (catalog && skuStripped) {
					product.getRecommendedParts(catalog, skuStripped, limit, displayList);
				}
			}

			/* Get Product Offers for Lead Gen */
			const $productOffersList = rp$(`.offer-dealer-list`);
			if ($productOffersList.length > 0) {
				let catalog = $productOffersList.data('catalog');
				let skuStripped = $productOffersList.data('sku-stripped');

				if (catalog && skuStripped) {
					product.getProductOffers(catalog, skuStripped);

					/* Handle zip code update
					.*-----------------------------------------*/
					const $changeLocationSubmitBtn = rp$('.change-location-form button.change-location-submit');
					const $postalCodeInput = rp$('.change-location-form input.change-location-input');
					if ($changeLocationSubmitBtn && $postalCodeInput) {
						$changeLocationSubmitBtn.on('click', HandleZipCodeUpdate.bind(this, $postalCodeInput, catalog, skuStripped));
						$postalCodeInput.on('keypress', function handleInputEnter(e) {
							if (e && e.which === 13) {
								HandleZipCodeUpdate($postalCodeInput, catalog, skuStripped);
							}
						});
					}
				}
			}

			/* Load Product Data
			.*-----------------------------------------*/
			var productData = null;
			try {
				productData = JSON.parse(rp$('#product_data').html());

			} catch (e) { /* do nothing if JSON is malformed */ }
			if (productData) {
				product.setProductData(productData);

				// Track Adobe DTM product detail view
				trackDetailsViewEvent();
			}

			/* Handle Option Changes
			.*-----------------------------------------*/
			if (rp$('.product-options').length) {
				product.handleOptionChange();
			}
			rp$('.product-options').on('change', '.option-select', (evt) => {
				evt.preventDefault();
				product.handleOptionChange();
			});

			rp$('.option-value-container').each((idx, optionElem) => {
				const overflowContentLimit = 78;
				const offSetHeightVal = rp$(optionElem).prop('offsetHeight');
				const optionId = rp$(optionElem).attr('data-button-option-id');
				const moreLessOptionClass = `.more-less-option.${optionId}`;
				if (offSetHeightVal > overflowContentLimit) {
					switchClass(rp$(moreLessOptionClass), 'toggle-enable', 'toggle-disable');
					switchClass(rp$(optionElem), 'hide-overflow-content', '');
				}
			});

			rp$('.option-buttons button').on('click', (evt) => {
				evt.preventDefault();
				const selectedOption = rp$(evt.currentTarget);
				const optionId = selectedOption.attr('data-button-option-id');
				const optionValueButtonClass = `.option-value-button.${optionId}`;
				if (selectedOption.hasClass('selected')) {
					// Reset the option selection if it is already selected
					selectedOption.removeClass('selected');
				} else {
					// Reset the option selection for the class
					rp$(optionValueButtonClass).removeClass('selected');
					// Add the selection to option
					selectedOption.addClass('selected');
				}
				product.handleOptionChange();
			});

			rp$('.more-less-option').on('click', (evt) => {
				evt.preventDefault();
				const optionId = rp$(document.activeElement).attr('data-button-option-id');
				const optionToggleClass = `.option-value-container.${optionId}`;
				if (rp$(document.activeElement).hasClass('active')) {
					switchClass(rp$(optionToggleClass), 'hide-overflow-content', 'show-overflow-content');
					switchClass(rp$(document.activeElement), '', 'active');
					rp$(document.activeElement).html('More');
				} else {
					switchClass(rp$(optionToggleClass), 'show-overflow-content', 'hide-overflow-content');
					switchClass(rp$(document.activeElement), 'active', '');
					rp$(document.activeElement).html('Less');
				}
			});

			rp$('.change-zip-confirm').on('click', (evt) => {
				evt.preventDefault();
				const zipCode = rp$('.zip-code-input').val();
				const warehouseId = rp$('#rp_shipping_estimate_message').data('inventory-warehouse-id');
				const customerId = rp$('#rp_shipping_estimate_message').data('inventory-warehouse-customer-id');
				handleZipChange(customerId, warehouseId, zipCode);
			});

		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
